import { Channel, ChannelInfo, ChannelDistribution } from "./channel";
import { ChannelCodec } from "./channel-codec";
import moment from "moment";
import { Subject } from "rxjs";
import { Token } from "../infrastructure/auth";
import {HttpStatusCode} from "@angular/common/http";

export abstract class ChannelRepository {
  channelSaved: Subject<Channel>;
  channelDeleted: Subject<number>;

  startCreate: (
    name: string,
    timeZoneId: number,
    logoX: number,
    logoY: number,
    logoHeight: number,
    logoWidth: number,
    isBlock: boolean,
  ) => Promise<{
    channelId: number;
    ChannelUid: string;
    createdDate: moment.Moment;
    newAccessToken: Token;
  }>;

  save: (
    channelInfo: ChannelInfo,
    availabilityZoneIdsToDeploy: number[],
    initCueperiodSetting: boolean,
  ) => Promise<void>;

  getChannelCodecs: (channelId?: number) => Promise<ChannelCodec[]>;

  addChannelCodec: (codec: ChannelCodec, channelId: number) => Promise<number>;

  updateChannelCodec: (codec: ChannelCodec, channelId: number) => Promise<void>;

  getChannelById: (id: number) => Promise<Channel>;

  generateOverrideChannelJSON: (
    channelId: number,
    availabilityZoneId: number,
  ) => Promise<string>;

  getChannelInfoById: (id: number) => Promise<ChannelInfo>;

  setChannelActiveState: (id: number, state: boolean) => Promise<void>;

  getChannelCode: (id: number, expiryDays: number) => Promise<string>;

  deleteChannel: (channel: Channel) => Promise<void>;

  checkIfSrtPortIsFree: (
    channelId: number,
    portNum: number,
  ) => Promise<boolean>;

  getChannelDistributionOptions: () => Promise<ChannelDistribution>;

  refreshCache: () => Promise<void>;
  updateLiveBroadcastShowUid: (
    channelId: number,
    showUid?: string,
  ) => Promise<void>;

  getTenantChannels: (tenantId?: number) => Promise<Channel[]>;
  getAllChannels: (
    tenantId?: number,
    isActive?: boolean,
    isCreatedReady?: boolean,
    includeDeleted?: boolean,
    isBlock?: boolean,
  ) => Promise<Channel[]>;
  updatePlaylistBy: (mediaIds: number[], layoutUids: string[]) => Promise<void>;
  generateDownloadChannelRecordingToken: (channelId: number,availabilityZoneId: number, fromTimeUtc: moment.Moment, toTimeUtc: moment.Moment) => Promise<string>;
  downloadChannelRecording: (token: string,availabilityZoneId: number, fromTimeUtc: moment.Moment, toTimeUtc: moment.Moment)=> Promise<HttpStatusCode>;
}
